import {Box, Typography, styled, Divider as MuiDivider} from '@mui/material';
export interface qouteBoxProps {
  qoute: string;
  author: string;
  bgcolor?: string;
}

const QouteMark = styled('span')<any>(props => ({
  ':before': {
    position: 'absolute',
    fontSize: '42px',
    margin: props.open ? '4px 0 0 -25px' : '4px 0 0 0px',
    content: props.open ? 'open-quote' : 'close-quote',
    fontFamily: 'Droid Sans,Comfortaa,san-serif',
  },
}));

const Divider = styled(MuiDivider)<any>(props => ({
  width: '10%',
  border: '1px solid #bfbfbf',
  backgroundColor: '#bfbfbf',
}));

const QouteSection = (props: qouteBoxProps) => {
  return (
    <Box
      {...props}
      sx={{
        backgroundColor: props.bgcolor || '#f3fbfb',
        px: {xxs: 5, md: 20},
        py: {xxs: 2, md: 5},
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Divider sx={{my: {xxs: 2, md: 5}}} />
      <Typography
        component={'p'}
        sx={{
          lineHeight: '48px',
          color: 'rgba(70, 70, 70, 0.7)',
          letterSpacing: '1px',
          fontFamily: 'Neuton,serif',
          fontStyle: 'italic',
          fontSize: '23px',
          fontWeight: 300,
        }}
      >
        <QouteMark open />
        {props.qoute}
        <QouteMark close />
      </Typography>
      <Typography
        component={'p'}
        sx={{
          mt: 3,
          fontSize: '24px',
          fontWeight: 700,
          color: 'secondary.main',
          fontStyle: 'italic',
        }}
      >
        {props.author}
      </Typography>
      <Divider sx={{my: 5}} />
    </Box>
  );
};

export default QouteSection;
